import {
  getRandomBrightColor,
  makeColorSchema
} from "./chunk-SNUDSNGS.js";
import "./chunk-EUXUH3YW.js";

// libs/core/src/lib/theme/themes/brand-color-schemes/random.style.ts
var randomStyle = () => makeColorSchema(getRandomBrightColor());
export {
  randomStyle
};
//# sourceMappingURL=random.style-5KLAHRBN.js.map
